// Module
var code = "<div class=\"disableEditing\" flex layout=\"column\"></div>";
// Exports
module.exports = code;